var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 11,
    viewBox: "0 0 68 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b5c775",
    d: "M33.154 5.5c0 3.028-2.417 5.5-5.377 5.5S22.4 8.528 22.4 5.5 24.817 0 27.777 0s5.377 2.472 5.377 5.5zm-1.276 0c0-2.306-1.847-4.194-4.101-4.194s-4.1 1.888-4.1 4.194 1.846 4.194 4.1 4.194c2.254 0 4.1-1.888 4.1-4.194z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b5c775",
    d: "M5.377 9.694c-2.254 0-4.1-1.888-4.1-4.194s1.846-4.194 4.1-4.194c1.14 0 2.145.472 2.906 1.222l.896-.917A5.274 5.274 0 0 0 5.377 0C2.417 0 0 2.472 0 5.5S2.417 11 5.377 11a5.274 5.274 0 0 0 3.802-1.611l-.896-.917c-.76.75-1.765 1.222-2.906 1.222z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b5c775",
    d: "M44.347 9.694c-2.254 0-4.1-1.888-4.1-4.194s1.846-4.194 4.1-4.194c1.14 0 2.145.472 2.906 1.222l.896-.917A5.274 5.274 0 0 0 44.347 0c-2.96 0-5.377 2.472-5.377 5.5s2.417 5.5 5.377 5.5a5.274 5.274 0 0 0 3.802-1.611l-.896-.917a4.058 4.058 0 0 1-2.906 1.222z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b5c775",
    d: "M12.786.31H11.51v10.417h1.276z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b5c775",
    d: "M36.716 3.56H35.44v7.167h1.276z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b5c775",
    d: "M20.316.31H19.04v10.417h1.276z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b5c775",
    d: "M19.692 4.83H12.17v1.306h7.522z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b5c775",
    d: "M57.25 9.39h-6.11v1.306h6.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b5c775",
    d: "M57.25.31h-6.11v1.306h6.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b5c775",
    d: "M36.063 2.504L33.89.31h4.345z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b5c775",
    d: "M53.012 5.723c0 .584-.38.945-.896.945s-.896-.334-.896-.945V4.39h.353v1.361c0 .389.244.583.543.583.299 0 .543-.194.543-.583V4.39h.353z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b5c775",
    d: "M54.1 6.642h.353V4.42H54.1zm.842-1.194l.896-1.028h-.434l-.924 1.028 1.005 1.194h.434z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b5c775",
    d: "M58.165 6.642l-.625-.86h-.407v.86h-.353V4.42h.788c.434 0 .733.278.733.694a.674.674 0 0 1-.408.64l.652.916h-.38zM57.16 5.448h.435c.244 0 .38-.14.38-.361 0-.223-.136-.361-.38-.361h-.435z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b5c775",
    d: "M60.75 6.249h-.977l-.163.361h-.38l.95-2.25h.11l.95 2.25h-.38zm-.488-1.222l-.353.916h.733z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b5c775",
    d: "M62.543 6.642h-.353V4.42h.353z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b5c775",
    d: "M65.422 4.416v2.25h-.108L63.983 5.11v1.5h-.353V4.36h.109l1.33 1.528v-1.5h.353z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b5c775",
    d: "M67.97 4.726h-1.087v.583h.815v.305h-.815v.695h1.113v.333H66.53V4.42h1.44z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderLogo2);
export default __webpack_public_path__ + "static/media/slider_logo2.f1bd04fe0d31ec9a2bb236da15517254.svg";
export { ForwardRef as ReactComponent };